import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
import { useMedia } from 'react-use';
import { Toaster } from 'sonner';

import { breakpoints } from '@/styles/util';

import { routes } from '@/utils/routes';

const toasterGap = { mobile: 16, desktop: 24 };
const toasterOffsetDesktop = { right: 40, bottom: 24 };
const toasterOffsetMobile = { right: 16, bottom: 16 };

// Page-specific toaster offsets on mobile devices
const mobileOffsetsOverrides: Record<string, Partial<typeof toasterOffsetMobile>> = {
  [routes.TOKEN_PROFILE]: { bottom: 84 },
};

export const appToasterVars = {
  gap: '--app-toaster-gap',
  bottomOffset: '--app-toaster-bottom-offset',
};

export const AppToaster = () => {
  const { pathname } = useRouter();
  const isMobile = useMedia(breakpoints.mobile, false);

  const gap = isMobile ? toasterGap.mobile : toasterGap.desktop;
  const mobileOffset = useMemo(
    () => ({ ...toasterOffsetMobile, ...mobileOffsetsOverrides[pathname] }),
    [pathname],
  );

  // Update toaster-gap and toaster-offset CSS var on breakpoint / page change
  useEffect(() => {
    document.documentElement.style.setProperty(appToasterVars.gap, `${gap}px`);

    const offset = isMobile ? mobileOffset : toasterOffsetDesktop;
    document.documentElement.style.setProperty(appToasterVars.bottomOffset, `${offset.bottom}px`);
  }, [gap, isMobile, mobileOffset]);

  return (
    <Toaster
      position="bottom-right"
      offset={toasterOffsetDesktop}
      mobileOffset={mobileOffset}
      gap={gap}
      expand={true}
      richColors={true}
    />
  );
};
